import { useContext, useEffect, useState } from "react";
import { useNavigate as useHistory } from "react-router-dom";
import CasClient, { constant } from "react-cas-client";
import { CasUserContext } from "../services/casUserContext";
import { authService } from "../services/auth.service";

const useCas = (attempLoginWithGateway = false) => {
  const history = useHistory();

  const casUserContext = useContext(CasUserContext);
  const [isLoading, setIsLoading] = useState(false);
  const CAS_PARAMS = process.env.REACT_APP_CAS.split("://");
  const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };

  //const casClient = new CasClient(process.env.REACT_APP_CAS, { version: constant.CAS_VERSION_2_0, });
  const casClient = new CasClient(CAS_PARAMS[1], casOptions);

  const goToNavigation = (site) =>{
    history(site)
  }

  useEffect(() => {
    if (!casUserContext.user) {
      //console.log("Entre en contexto");
      (async function () {
          try {
              //_casUserContext.setChecking(true);
              //console.log(_casUserContext);
              await attemptCasLogin(attempLoginWithGateway);
          } catch (err) {
              //console.error('usecas:', err);
          }
      })();
    }else
      if (!casUserContext.user && !casUserContext.checking) {
        (async function () {
          try {
            casUserContext.setChecking(true);
            await attemptCasLogin(attempLoginWithGateway);
          } catch (error) {
            console.error(error);
          }
        })();
      }
  }, []);
  
  function attemptCasLogin(gateway) {
    return new Promise((resolve, reject) => {
      casClient
        .auth()
        .then((successRes) => {
          // Login user in state / locationStorage ()
          // eg. loginUser(response.user);
          authService.login(successRes.user);
          const u = authService.currentUser.subscribe(currentUser => {
            if (currentUser && currentUser.idpersona) {
               //console.log(currentUser)              
               casUserContext.setToken(currentUser.token)
               casUserContext.setUserData(currentUser)
               casUserContext.setUser(true)
               setIsLoading(false);
               goToNavigation(successRes.currentPath);
               //console.log(casUserContext);
            }
          });          
        })
        .catch((errorRes) => {
          setIsLoading(true);
          goToNavigation(errorRes.currentPath);
          //goToNavigation("inicio/error-login");
          //console.log(casUserContext);
          reject(errorRes);
        });
    });
  }

  function logout(path = "/") {
    casClient.logout("/");
  }

  return { isLoading, attemptCasLogin, logout };
};

export default useCas;